import * as GlobalModules from './global';
import * as PXBlocks from '../blocks/index';
import Analytics, { EventTypes } from "./analytics"; // Ensure Analytics is imported correctly

import './crutch.scss';

const ModulesAndBlocks = { ...GlobalModules, ...PXBlocks };




document.addEventListener('DOMContentLoaded', () => {
	for (const key in ModulesAndBlocks) {
		// Initialize modules/blocks on the frontend (i.e. when window.acf is undefined)
		if (Object.hasOwnProperty.call(ModulesAndBlocks, key) && !window.acf) ModulesAndBlocks[key].init();

		// Make sure blocks JS render properly in the editor (cf. https://www.advancedcustomfields.com/resources/acf_register_block_type/)
		if (window.acf && Object.hasOwnProperty.call(PXBlocks, key))
			window.acf.addAction(`render_block_preview/type=${PXBlocks[key].name}`, PXBlocks[key].init);
	}
});

(function () {
  Analytics.getInstance();
  analytics.track(EventTypes.PageView, { url: window.location.href });
})();


/**
 * @fileoverview Injects and manages the Legal Update banner with accept/dismiss logic.
 * Ensures accessibility and sets a dismissal cookie to avoid future display.
 */
(() => {
  // Locate the main banner element
  const banner = document.getElementById("legal-update-banner");

  // Exit early if the banner is not present on the page
  if (!banner) return;

  // Locate the inner container where we'll append the dismiss button
  const bannerContainer = banner.querySelector(".notice-container");

  // Exit if structure is unexpected
  if (!bannerContainer) {
    console.warn("Banner container not found inside #legal-update-banner.");
    return;
  }

  // Create the dismiss/accept button dynamically
  const closeButton = document.createElement("a");
  closeButton.id = "dismiss-legal-banner";
  closeButton.setAttribute("aria-label", "Dismiss notice"); // Accessibility
  closeButton.innerHTML = "Accept"; // Button label text

  // Append the button inside the notice container
  bannerContainer.appendChild(closeButton);

  // Bind click event to dismiss banner and store a 30-day cookie
  closeButton.addEventListener("click", () => {
    banner.remove(); // Remove the banner from view

    // Set dismissal cookie with 30-day expiration
    const now = new Date();
    const expirationDate = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000);
    document.cookie = `legal-banner-dismissed=true; expires=${expirationDate.toUTCString()}; path=/`;
  });
})();